import React from 'react'
import { FaChartLine } from 'react-icons/fa'
import ModuleStatusChart from './ModuleStatusChart'
import ContentTypeChart from './ContentTypeChart'
import ContentAnalyticsChart from './ContentAnalyticsChart'
import './PersonalDashboardSummary.scss'

const PersonalDashboardSummary = ({ analysis }) => {
  if (!analysis) {
    return null;
  }

  const { moderator, statistics } = analysis;

  return (
    <div className="personal-dashboard-summary">
      <div className="summary-header">
        <h2 className="summary-title">
          <FaChartLine className="title-icon" />
          Welcome, {moderator.name}!
        </h2>
        <p className="summary-subtitle">Your personal module moderation overview</p>
      </div>

      <div className="summary-content">
        <div className="charts-grid">
          <ModuleStatusChart statistics={statistics} />
          <ContentTypeChart statistics={statistics} />
        </div>
        <ContentAnalyticsChart statistics={statistics} />
      </div>
    </div>
  );
};

export default PersonalDashboardSummary;
